// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".spinner[data-v-59f5733c]{animation:loading-spinner-59f5733c 1s linear infinite}@keyframes loading-spinner-59f5733c{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
